<template>
  <a
    @click="onClick"
    :disabled="disabled ? true : false"
    class="button is-primary"
    :class="{'is-loading': loading, 'is-pulled-right': right}"
    :icon="icon"
  >
    <span
      class="icon"
      v-if="icon"
    >
      <i class="fa fa-save"></i>
    </span>
    <slot> <span>Save changes</span> </slot>
  </a>
</template>

<script>
  export default {
    name: "save-button",
    props: {
      icon: {
        default: true,
        type: Boolean
      },
      loading: {
        default: false,
        type: Boolean
      },
      right: {
        default: false,
        type: Boolean
      },
      disabled: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      onClick () {
        if (!this.disabled) this.$emit("click");
      }
    }
  };
</script>

<style scoped>
</style>
